import { jsx as i, jsxs as y } from "react/jsx-runtime";
import { a as L, u as k } from "./useAEMEditorComponentSize-4d8ec5ae.mjs";
import { QUERIES as u, BREAKPOINTS as w } from "@fcamna/shared-component-foundations";
import d, { useRef as F, useMemo as A, useState as M, useEffect as j } from "react";
import r, { css as D } from "styled-components";
import { u as R } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as O } from "./useWindowSize-88e90e04.mjs";
import { h as N } from "./hTag-27bb1617.mjs";
import { Icon as _ } from "./icon.js";
import { IconButton as Y } from "./iconButton.js";
import { MediaDisclosureButton as Q } from "./mediaDisclosureButton.js";
import { S } from "./screenReaderOnly-fd82ed96.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "@fcamna/shared-icons";
import "./index-65016bfa.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
const q = "50%", G = "70%", K = r.div`
  ${({ theme: { componentStyles: e } }) => D(e)};
  ${({ width: e }) => ({ width: e })}
  align-items: ${(e) => e.theme.components.landingHeroVideoV1.Wrapper.alignItems};
  display: ${(e) => e.theme.components.landingHeroVideoV1.Wrapper.display};
  position: ${(e) => e.theme.components.landingHeroVideoV1.Wrapper.position};
  height: ${(e) => e.theme.components.landingHeroVideoV1.Wrapper.height};
  min-width: ${(e) => e.theme.components.landingHeroVideoV1.Wrapper.minWidth};

  @media ${u.tabletAndUp} {
    height: ${(e) => e.theme.components.landingHeroVideoV1.Wrapper.tabletAndUp.height};
  }
  @media ${u.laptopAndUp} {
    height: ${(e) => e.theme.components.landingHeroVideoV1.Wrapper.laptopAndUp.height};
  }
`, J = r.div`
  position: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.position};
  z-index: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.zIndex};
  display: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.display};
  flex-direction: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.flexDirection};
  justify-content: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.justifyContent};
  align-items: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.alignItems};
  gap: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.gap};
  align-self: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.alignSelf};
  padding: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.padding};

  @media ${u.tabletAndUp} {
    padding: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.tabletAndUp.padding};
  }
  @media ${u.laptopAndUp} {
    padding: ${(e) => e.theme.components.landingHeroVideoV1.HeadingContent.laptopAndUp.padding};
  }
`, X = r.div`
  position: ${(e) => e.theme.components.landingHeroVideoV1.VideoWrapper.position};
  top: ${(e) => e.theme.components.landingHeroVideoV1.VideoWrapper.top};
  left: ${(e) => e.theme.components.landingHeroVideoV1.VideoWrapper.left};
  height: ${(e) => e.theme.components.landingHeroVideoV1.VideoWrapper.height};
  width: ${(e) => e.theme.components.landingHeroVideoV1.VideoWrapper.width};
  overflow: ${(e) => e.theme.components.landingHeroVideoV1.VideoWrapper.overflow};
  background-color: ${(e) => e.theme.components.landingHeroVideoV1.VideoWrapper.backgroundColor};
  border-radius: ${(e) => e.theme.components.landingHeroVideoV1.VideoWrapper.borderRadius};
`, Z = r.div`
  position: ${(e) => e.theme.components.landingHeroVideoV1.VideoOverlayWrapper.position};
  top: ${(e) => e.theme.components.landingHeroVideoV1.VideoOverlayWrapper.top};
  left: ${(e) => e.theme.components.landingHeroVideoV1.VideoOverlayWrapper.left};
  height: ${(e) => e.theme.components.landingHeroVideoV1.VideoOverlayWrapper.height};
  width: ${(e) => e.theme.components.landingHeroVideoV1.VideoOverlayWrapper.width};
  overflow: ${(e) => e.theme.components.landingHeroVideoV1.VideoOverlayWrapper.overflow};
  background-color: ${(e) => e.theme.components.landingHeroVideoV1.VideoOverlayWrapper.backgroundColor};
  z-index: ${(e) => e.theme.components.landingHeroVideoV1.VideoOverlayWrapper.zIndex};
  background: ${(e) => e.theme.components.landingHeroVideoV1.VideoOverlayWrapper.background};

  ${(e) => e.isPlaying ? `opacity: ${e.playingOpacity};` : `opacity: ${e.pausedOpacity};`}
`, ee = r.div`
  height: ${(e) => e.theme.components.landingHeroVideoV1.VideoElementWrapper.height};
  width: ${(e) => e.theme.components.landingHeroVideoV1.VideoElementWrapper.width};

  div,
  video {
    position: ${(e) => e.theme.components.landingHeroVideoV1.VideoElementWrapper.divVideo.position};
    min-height: ${(e) => e.theme.components.landingHeroVideoV1.VideoElementWrapper.divVideo.minHeight};
    width: ${(e) => e.theme.components.landingHeroVideoV1.VideoElementWrapper.divVideo.width};
    max-width: ${(e) => e.theme.components.landingHeroVideoV1.VideoElementWrapper.divVideo.maxWidth};
    -o-object-fit: ${(e) => e.theme.components.landingHeroVideoV1.VideoElementWrapper.divVideo.objectFit};
    object-fit: ${(e) => e.theme.components.landingHeroVideoV1.VideoElementWrapper.divVideo.objectFit};
    z-index: ${(e) => e.theme.components.landingHeroVideoV1.VideoElementWrapper.divVideo.zIndex};
  }
`, oe = r(N)`
  && {
    color: ${(e) => e.theme.components.landingHeroVideoV1.VideoTitleWrapper.color};
    font-family: ${(e) => e.theme.components.landingHeroVideoV1.VideoTitleWrapper.fontFamily};
    font-weight: ${(e) => e.theme.components.landingHeroVideoV1.VideoTitleWrapper.fontWeight};
    font-size: ${(e) => e.theme.components.landingHeroVideoV1.VideoTitleWrapper.fontSize};
    line-height: ${(e) => e.theme.components.landingHeroVideoV1.VideoTitleWrapper.lineHeight};
    letter-spacing: ${(e) => e.theme.components.landingHeroVideoV1.VideoTitleWrapper.letterSpacing};
  }
`, ne = r.div`
  font-family: ${(e) => e.theme.components.landingHeroVideoV1.VideoBodyWrapper.fontFamily};
  font-weight: ${(e) => e.theme.components.landingHeroVideoV1.VideoBodyWrapper.fontWeight};
  font-size: ${(e) => e.theme.components.landingHeroVideoV1.VideoBodyWrapper.fontSize};
  line-height: ${(e) => e.theme.components.landingHeroVideoV1.VideoBodyWrapper.lineHeight};
  letter-spacing: ${(e) => e.theme.components.landingHeroVideoV1.VideoBodyWrapper.letterSpacing};
  color: ${(e) => e.theme.components.landingHeroVideoV1.VideoBodyWrapper.color};

  @media ${u.tabletAndUp} {
    font-weight: ${(e) => e.theme.components.landingHeroVideoV1.VideoBodyWrapper.tabletAndUp.fontWeight};
    font-size: ${(e) => e.theme.components.landingHeroVideoV1.VideoBodyWrapper.tabletAndUp.fontSize};
    line-height: ${(e) => e.theme.components.landingHeroVideoV1.VideoBodyWrapper.tabletAndUp.lineHeight};
  }
`, te = r.div`
  z-index: ${(e) => e.theme.components.landingHeroVideoV1.VideoPlaybackButtonWrapper.zIndex};
`, ie = r.div`
  display: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.display};
  flex-direction: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.flexDirection};
  margin-top: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.marginTop};
  gap: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.gap};
  width: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.width};

  @media ${u.tabletAndUp} {
    display: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.tabletAndUp.display};
    flex-direction: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.tabletAndUp.flexDirection};
    gap: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.tabletAndUp.gap};
    margin-top: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.tabletAndUp.marginTop};
    padding: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.tabletAndUp.padding};
    align-items: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.tabletAndUp.alignItems};
    align-self: ${(e) => e.theme.components.landingHeroVideoV1.VideoButtonsWrapper.tabletAndUp.alignSelf};
  }
`;
function de({ children: e, ...t }) {
  return /* @__PURE__ */ i(X, { ...t, children: e });
}
const re = r.div`
  display: ${(e) => e.theme.components.landingHeroVideoV1.PlayButtonWrapperWithTextButton.display};
  align-items: ${(e) => e.theme.components.landingHeroVideoV1.PlayButtonWrapperWithTextButton.alignItems};
  gap: ${(e) => e.theme.components.landingHeroVideoV1.PlayButtonWrapperWithTextButton.gap};
`;
function ae({ children: e, ...t }) {
  const n = d.Children.map(e, (o) => o && d.isValidElement(o) ? o : null);
  return /* @__PURE__ */ y(ie, { ...t, children: [
    n && n.slice(0, n.length - 2),
    /* @__PURE__ */ y(re, { children: [
      n && n[n.length - 2],
      n && n[n.length - 1]
    ] })
  ] });
}
function pe({ children: e, ...t }) {
  return /* @__PURE__ */ i(ne, { ...t, children: e });
}
function T({ children: e, ...t }) {
  return /* @__PURE__ */ i(J, { ...t, children: e });
}
function le({ children: e, headingLevel: t = "h1", ...n }) {
  return /* @__PURE__ */ i(
    oe,
    {
      as: t,
      ...n,
      children: e
    }
  );
}
function me({
  onClick: e,
  size: t,
  accessibilityOptions: n,
  playButtonAccessibilityOptions: o,
  ...H
}) {
  var s, p;
  const { isPlaying: a, playbackIcon: c, handleOnClick: h, playButtonSize: V } = d.useContext(v);
  function f($) {
    h(), e == null || e($, !a);
  }
  return /* @__PURE__ */ y(te, { ...H, children: [
    /* @__PURE__ */ i(
      Y,
      {
        icon: /* @__PURE__ */ i(_, { name: c }),
        onClick: f,
        size: t || V,
        accessibilityOptions: a ? { ariaLabel: "Pause", ...(o == null ? void 0 : o.pauseButton) || n } : { ariaLabel: "Play", ...(o == null ? void 0 : o.playButton) || n }
      }
    ),
    /* @__PURE__ */ i(S, { "aria-live": "assertive", children: a ? ((s = o == null ? void 0 : o.playing) == null ? void 0 : s.ariaLabel) || "Playing" : ((p = o == null ? void 0 : o.paused) == null ? void 0 : p.ariaLabel) || "Paused" }),
    /* @__PURE__ */ i(S, { "aria-live": "assertive", children: a ? "Playing" : "Paused" })
  ] });
}
function Ve({
  videoProps: e,
  onPlay: t,
  onPause: n,
  onEnded: o,
  loopAmount: H = 0,
  pauseTime: a = -1,
  ...c
}) {
  const { defaultVideoProps: h, loopCount: V, setLoopCountFunc: f } = d.useContext(v), { onPlay: s, onPause: p, loop: $, ref: g, ...C } = h, W = Math.floor(H);
  function x() {
    s(), t == null || t();
  }
  function b() {
    p(), n == null || n();
  }
  function B() {
    if (W > 0) {
      const l = g == null ? void 0 : g.current;
      V + 1 < W ? (f(V + 1), l.currentTime = 0, l.play()) : (a >= 0 && (l.currentTime = a), l.pause());
    }
    o == null || o();
  }
  return /* @__PURE__ */ i(
    ee,
    {
      videoProps: e,
      ...c,
      children: /* @__PURE__ */ i(
        "video",
        {
          ...C,
          loop: W > 0 ? !1 : $,
          ...e,
          onPlay: x,
          onPause: b,
          onEnded: B,
          ref: g
        }
      )
    }
  );
}
function se({
  playingOpacity: e = q,
  pausedOpacity: t = G,
  ...n
}) {
  const { isPlaying: o } = d.useContext(v);
  return /* @__PURE__ */ i(
    Z,
    {
      playingOpacity: e,
      pausedOpacity: t,
      isPlaying: o,
      ...n
    }
  );
}
const v = d.createContext({
  defaultVideoProps: {
    loop: !0,
    ref: void 0,
    onPlay: () => {
    },
    onPause: () => {
    }
  },
  isPlaying: !1,
  playbackIcon: "playFilled",
  playButtonSize: "medium",
  handleOnClick: () => {
  },
  loopCount: 0,
  setLoopCountFunc: (e) => e
});
function m({ children: e, disclosureLinks: t, ...n }) {
  const o = R({ label: "Landing Hero Video V1" }), H = "medium", [a, c] = d.useState("playFilled"), [h, V] = d.useState(!1), [f, s] = d.useState(0), p = d.useRef(null), $ = "100%", g = F(null), C = A(() => L.AuthoringUtils.isInEditor(), []), [W] = k(g, C, $);
  function x() {
    c("playFilled"), V(!1);
  }
  function b() {
    c("pause"), V(!0);
  }
  function B() {
    const U = p == null ? void 0 : p.current;
    h ? U.pause() : (s(0), U.play());
  }
  const { width: l } = O(), E = {
    right: ["108px", "108px", "20px"],
    bottom: ["14px", "14px", "14px"]
  }, [I, P] = M(0);
  j(() => {
    l > w.laptopMin ? P(0) : l < w.laptopMin && l > w.tabletMin ? P(1) : P(2);
  }, [l]);
  const z = {
    playsInline: !0,
    autoPlay: !0,
    muted: !0,
    loop: !0,
    onPlay: b,
    onPause: x,
    ref: p
  };
  return /* @__PURE__ */ i(
    K,
    {
      ...n,
      className: "props.className",
      ref: g,
      width: W,
      ...o,
      children: /* @__PURE__ */ y(
        v.Provider,
        {
          value: {
            defaultVideoProps: z,
            isPlaying: h,
            handleOnClick: B,
            playbackIcon: a,
            playButtonSize: H,
            loopCount: f,
            setLoopCountFunc: s
          },
          children: [
            t && /* @__PURE__ */ i(
              Q,
              {
                ...t,
                alignment: "bottom-right",
                containerPosition: {
                  bottom: E.bottom[I],
                  right: E.right[I]
                }
              }
            ),
            e
          ]
        }
      )
    }
  );
}
m.Content = T;
m.HeaderContainer = T;
m.VideoContainer = de;
m.Title = le;
m.Body = pe;
m.PlaybackButton = me;
m.CTAButtonContainer = ae;
m.VideoElement = Ve;
m.Overlay = se;
export {
  m as LandingHeroVideoV1
};
